module.exports = __webpack_public_path__ + "static/media/placeholder.008d5e26.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Results/Contacts/placeholder.png
// module id = 598
// module chunks = 2